import { LoginSuccess } from '@/components/animations';
import { AnimationProps } from '@/components/animations/types';
import { LoginContextType } from '@/hooks/useLogin';
import { _s } from '@/locale';
type VerifySuccessProps = Pick<LoginContextType, 'email'> & Pick<AnimationProps, 'onAnimationComplete'>;
const translationKey = 'VerifyOTP';
const VerifySuccess = ({ email, onAnimationComplete }: VerifySuccessProps) => {
  return (
    <>
      <p className="text-fg_secondary pb-sm text-m">
        {_s(`${translationKey}.checkInbox`)}
        <span className="text-fg_link">{email.value}</span>
      </p>
      <div className="py-lg flex flex-col items-center justify-center">
        <LoginSuccess loop={false} onAnimationComplete={onAnimationComplete} />
        <p className="text-h-m font-bold">{_s(`${translationKey}.success`)}</p>
      </div>
    </>
  );
};
export default VerifySuccess;
